import React, { useEffect, useState, useMemo } from 'react';
import '../tableComponent/tablecomponant.css'
import { useSelector } from 'react-redux';

const AddComponent = (props) => {

  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');
  const [keys, setKeys] = useState([]);
  const [hasContributor, setHasContributor] = React.useState(false);

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
  };

  const sortedData = useMemo(() => [...props.tableData], [props.tableData]);

  const isRowTotal = (row) => row.Region?.includes("Total");
  const isRegionExactlyTotal = (row) => row.Region === "Total";

  const regularRows = sortedData.filter(row => !isRegionExactlyTotal(row) && !isRowTotal(row)).map(row => {
    const { Lost, ...rest } = row;
    return rest;
  });

  if (sortColumn) {
    regularRows.sort((a, b) => {
      const valueA = a[sortColumn] ?? '';
      const valueB = b[sortColumn] ?? '';

      const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);
      const isDate = (value) => value && !isNaN(Date.parse(value));

      if (valueA === '' && valueB === '') return 0;
      if (valueA === '') return sortOrder === 'asc' ? 1 : -1;
      if (valueB === '') return sortOrder === 'asc' ? -1 : 1;

      if (isNumeric(valueA) && isNumeric(valueB)) {
        return sortOrder === 'asc' ? parseFloat(valueA) - parseFloat(valueB) : parseFloat(valueB) - parseFloat(valueA);
      } else if (isDate(valueA) && isDate(valueB)) {
        return sortOrder === 'asc' ? new Date(valueA) - new Date(valueB) : new Date(valueB) - new Date(valueA);
      } else {
        return sortOrder === 'asc' ? String(valueA).localeCompare(String(valueB)) : String(valueB).localeCompare(String(valueA));
      }
    });
  }

  const columnOrder = ["Region", "Total", "GPUsEarmarked", "GPUsCommitted", "GPUsAllocated", "GPUsAvailable"];

  const calculateColumnTotals = (data) => {
    const totalsRow = { Region: "Total" };
    columnOrder.forEach((column) => {
      if (column !== "Region") {
        totalsRow[column] = data.reduce((acc, row) => {
          const value = row[column];
          return value !== undefined && value !== '' && !isNaN(value) ? acc + parseFloat(value) : acc;
        }, 0);
      }
    });
    return totalsRow;
  };

  const totalsRow = calculateColumnTotals(regularRows);
  const processedData = useMemo(() => [...regularRows, totalsRow], [regularRows, totalsRow]);

  const handleRowSelect = (data) => {
    props.getSelectedRow({ data, edit: true })
    let dataType = ''
    if (props.type === "gpu") {
      dataType = 'gpu'
    } 
    props.handleModal(dataType, props.header)
  };

  function convertUSFormate(num) {
    const numericRegex = /^[0-9]+$/;
    if (numericRegex.test(num)) {
      return parseInt(num).toLocaleString("en-US");
    } else {
      return num;
    }
  }

  const columnDisplayNames = {
    "Region": "Region",
    "Total": "Total GPUs",
    "GPUsEarmarked": "GPUs Earmarked",
    "GPUsCommitted": "GPUs Committed",
    "GPUsAllocated": "GPUs Allocated",
    "GPUsAvailable": "GPUs Available"
  };

  useEffect(() => {
    setHasContributor(sessionStorage.getItem("ActiveRole") == "Contributor");
  }, []);

  useEffect(() => {
    if (props.tableData.length !== 0) {
      setKeys(Object.keys(props.tableData[0]));
    }
  }, [props.tableData]);
  return (
    <>
      <div className="table-container">
        <table style={{ borderSpacing: '0px', width: '100%', overflow: 'scroll' }}>
          <thead style={{ backgroundColor: 'rgb(233, 233, 233)', position: 'sticky', top: 0 }}>
            <tr>
              <th style={{ ...headerStyle, display: (props.header === "Live" || props.type === "gpu") && hasContributor ? '' : 'none' }} />
              {columnOrder.map((key) => (
                <th
                  key={key}
                  style={{ 
                    ...headerStyle, 
                    textAlign: key === 'Region' ? 'left' : 'center', 
                    cursor: props.header !== "Live" ? 'pointer' : 'auto', 
                    width: key === 'Region' ? "20vw": "fit-content"
                  }}
                  onClick={props.header !== "Live" ? () => handleSort(key) : undefined}
                  className={key === sortColumn ? (sortOrder === 'asc' ? 'sort-asc' : 'sort-desc') : ''}
                >
                  {columnDisplayNames[key]}
                  {key === sortColumn && (
                    <i className={`fa fa-caret-${sortOrder === 'asc' ? 'up' : 'down'} sort-icon`} />
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {processedData.map((row, rowIndex) => {
              const isTotalRow = isRegionExactlyTotal(row);
              return (
                <tr
                key={rowIndex}
                style={{
                  backgroundColor: isTotalRow ? '#f6f6f6' : rowIndex % 2 === 1 ? '#F0F0F0' : 'white',
                  color: isTotalRow ? 'black' : 'inherit',
                  fontWeight: isTotalRow ? 'bold' : 'normal',
                  position: isTotalRow ? 'sticky' : 'static',
                  bottom: isTotalRow ? 0 : 'auto',
                  zIndex: isTotalRow ? 1 : 'auto'
                }}
              >            
                  <td style={{ alignItems: 'center', justifyContent: 'center', display: (props.header === "Live" || props.type === "gpu") && hasContributor ? '' : 'none' }}>
                    <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                      <i
                        onClick={() => handleRowSelect(row)}
                        className="fa fa-edit icon"
                        style={{ color: '#4B81FF', marginRight: '10px', display: row['Region']?.includes("Total") ? 'none' : '' }}
                      ></i>
                    </div>
                  </td>
                  {columnOrder.map((key) => (
                    <td
                      key={key}
                      style={{
                        ...bodyStyle,
                        textAlign: key !== 'Region' ? 'center' : '',
                        fontWeight: isTotalRow ? 'bold' : 'normal',
                        color: isTotalRow ? 'black' : 'inherit',
                        width: key === 'Region' ? "20vw": "fit-content"
                      }}
                    >
                      {row[key] !== undefined && row[key] !== '' ? convertUSFormate(row[key]) : <span>0</span>}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};
const headerStyle = {
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '0px',
  textAlign: 'left',
  backgroundColor: '#e9e9e9',
  height: '30px',
  padding: '10px',
  position: 'sticky',
  top: 0,
  color: '#000000',
};

const bodyStyle = {
  fontFamily: 'Segoe UI',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  letterSpacing: '0px',
  textAlign: 'left',
  height: '32px',
  padding: '10px'
};

export default AddComponent;